import React, { useId, useState } from "react";
import { Controller } from "react-hook-form";
import "./BidNote.css";

export const countWords = value => (value || "").trim().split(/\s+/).filter(Boolean).length;

export function BidNoteInput({ control, watch }) {
  const id = useId();
  const count = countWords(watch("note"));
  const [expanded, setExpanded] = useState(false);
  const invalid = count > 100;
  return <Controller name="note" control={control} defaultValue="" render={({ field }) => (
    <div className="bid-note-input">
      <label className="bid-note-option">
        <input type="checkbox" checked={expanded || Boolean(field.value)} onChange={event => {
          setExpanded(event.target.checked);
          if (!event.target.checked) field.onChange("");
        }} />
        Add a comment on your bid <span>(optional)</span>
      </label>
      {(expanded || Boolean(field.value)) && <>
        <label htmlFor={id} className="bid-note-label">Comment on your bid</label>
        <div className={`bid-note-editor${invalid ? " bid-note-editor--invalid" : ""}`}>
          <textarea {...field} id={id} rows={4} aria-invalid={invalid} aria-describedby={`${id}-count`} placeholder="Add any details you would like the customer to know…" />
          <div id={`${id}-count`} className="bid-note-count">
            <span>{invalid ? "Word limit exceeded" : "Max 100 words"}</span>
            <span>{invalid ? `${count} / 100 words` : `${100 - count} left`}</span>
          </div>
          <div className="bid-note-progress" style={{ width: `${Math.min(count, 100)}%` }} />
        </div>
        {invalid && <p className="bid-note-error" role="alert">Shorten your comment to 100 words or fewer before submitting.</p>}
      </>}
    </div>
  )} />;
}

export function BidNote({ note }) {
  return note?.trim() ? <div className="bid-note-display">
    <p className="bid-note-heading">Comment from the installer</p><p>{note}</p>
  </div> : null;
}
